import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAmplitude } from './AmplitudeProvider';
import { selectors as variantsSelectors } from './variantsSlice';

export function useFeatureFlag(
    flagName: string,
    defaultValue = false,
    variantName = 'on',
) {
    const { experiment } = useAmplitude();
    const hasFetched = useSelector(variantsSelectors.selectHasFetched);

    const [isEnabled, setIsEnabled] = useState(defaultValue);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!experiment || !hasFetched) {
            return;
        }

        const flag = experiment.variant(flagName);

        setIsLoading(false);

        // Fire exposure for any real assignment (treatment or control),
        // but not for fallback/unassigned users per Amplitude docs.
        // `flag.key` is set for any real assignment (treatment or control).
        // The SDK returns `{}` (no key) for unassigned/fallback users.
        // Control groups may have `key` without `value`, so we check `key`.
        if (flag?.key) {
            experiment.exposure(flagName);
        }

        setIsEnabled(flag?.value === variantName);
        // defaultValue is intentionally not in the dep array as it's being used by useState(defaultValue)
    }, [experiment, flagName, hasFetched, variantName]);

    return { isEnabled, isLoading };
}
